// Re-export useNotify from kstone-vue
import { useNotify as useNotifyBase, type NotifyOptions } from '@siclop/kstone-vue'

export { useNotifyBase as useNotify, type NotifyOptions }

// Also export standalone functions for convenience (backward compatibility)
const notifier = useNotifyBase()

export const notify = {
  success: (message: string, options?: NotifyOptions) => notifier.success(message, options),
  error: (message: string, options?: NotifyOptions) => notifier.error(message, options),
  warning: (message: string, options?: NotifyOptions) => notifier.warning(message, options),
  info: (message: string, options?: NotifyOptions) => notifier.info(message, options)
}
